import { Dialog } from 'vant';
import request from '@/plugins/axios';

let lessonId = 0;
let lastPlayingTime = 0;
let player = null;
const startTime = Math.floor(Date.now() / 1000);
let currentPlayerTimer = null;
let detailId = 0;

const getCurrentTime = () => {
  if (player.tagName === 'AUDIO') {
    console.log(player.tagName === 'AUDIO');
    return Math.floor(player.currentTime || 0);
  }
  return Math.floor(player.currentTime() || 0);
};
const pendingApi = (uri, data) => {
  if (localStorage) {
    localStorage.setItem(`pending_api:${uri}`, JSON.stringify(data));
  }
  // console.log(`pending_api:${uri}`, data);
};

const campPlayCommon = {
  watch: {
    lessonId() {
      lastPlayingTime = 0;
    }
  },
  methods: {
    // 获取上次播放位置 , _startTime
    init(_lessonId, _detailId, _player) {
      lessonId = _lessonId;
      detailId = _detailId;
      player = _player;

      if (localStorage) {
        const playerData = localStorage.getItem(`lesson_player_time:${lessonId}`);
        if (playerData) {
          // eslint-disable-next-line no-eval
          lastPlayingTime = eval(`(${playerData})`).value;
        }
      }
      if (!lastPlayingTime) {
        request.get(`/api/lesson/get_playing_time?lesson_id=${lessonId}`)
          .then((res) => {
            if (res && res.data.result) {
              lastPlayingTime = res.result;
            }
          });
      }
    },
    startLessonPlayerTime(_startTime) {
      // 保存播放记录和播放时间
      if (currentPlayerTimer) {
        clearInterval(currentPlayerTimer);
      }

      currentPlayerTimer = setInterval(() => {
        const playerTime = getCurrentTime();
        if (!playerTime) {
          return;
        }

        const data = {
          start_time: _startTime || startTime,
          end_time: Math.floor(Date.now() / 1000),
          player_time: playerTime,
          detail_id: detailId || this.detailId,
        };
        pendingApi(`/api/lesson/log_lesson_play2?lesson_id=${lessonId}`, data);

        if (localStorage && playerTime) {
          localStorage.setItem(`lesson_player_time:${lessonId}`, JSON.stringify({ value: playerTime, expires: Date.now() + 30 * 24 * 3600 * 1000 }));
        }
      }, 5000);
    },
    stopLessonPlayerTime(_endTime = Math.floor(Date.now() / 1000)) {
      if (currentPlayerTimer) {
        clearInterval(currentPlayerTimer);
      }

      const uri = `/api/lesson/log_lesson_play2?lesson_id=${lessonId}`;
      const key = `pending_api:${uri}`;
      let data = localStorage.getItem(key);

      if (!data) {
        return;
      }

      try {
        data = JSON.parse(data);
      } catch (err) {
        console.log(err);
        data = {};
      }

      data.end_time = _endTime;

      request.post(uri, data).then((res) => {
        const resData = res.data;
        if (!resData) {
          localStorage.removeItem(key);
        } else if (resData.result) {
          localStorage.removeItem(key);
        }
      }).catch(() => {
        // 服务器异常
        console.error(`异常err，移除待定请求:${key}`);
        localStorage.removeItem(key);
      });
    },
    getDuration() {
      return player.duration() || this.duration;
    },
    setCurrentTime(time) {
      if (player.tagName === 'AUDIO') {
        player.currentTime = time;
      } else {
        player.currentTime(time);
      }
    },
    restorePlayerTime(_duration) {
      const duration = _duration || this.getDuration();

      if (lastPlayingTime > 10 && (duration - lastPlayingTime > 10)) {
        let timeText = `${lastPlayingTime}秒`;

        if (lastPlayingTime >= 60) {
          timeText = `${Math.floor(lastPlayingTime / 60)}分${lastPlayingTime % 60}秒`;
        }

        Dialog.confirm({
          title: '消息',
          message: `是否从上次播放位置(${timeText})继续播放？`,
          confirmButtonColor: '#FF9645',
          cancelButtonColor: '#999999',
        })
          .then(() => {
            // on confirm
            this.setCurrentTime(lastPlayingTime);
            player.play();
          })
          .catch(() => {
            // on cancel
          });
      }
    },
  },
};

export default campPlayCommon;
